import React, { Component } from "react";
import { CardBody } from "reactstrap";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Row,
  Col
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
import { withTranslation } from "react-i18next";

class LicencePrices extends Component<{ prices: any; onPriceChange: any}, any> {
  constructor(props: any) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: "1",
      withVAT1: this.props.prices[0].priceWithVAT,
      withoutVAT1: this.props.prices[0].priceWithoutVAT,
      withVAT2: this.props.prices[1].priceWithVAT,
      withoutVAT2: this.props.prices[1].priceWithoutVAT,
      withVAT3: this.props.prices[2].priceWithVAT,
      withoutVAT3: this.props.prices[2].priceWithoutVAT
    };
  }

  componentDidMount() {
    this.updatePrices();
  }

  onChange(event: any, what: string, index: any) {
    if (what == "withVAT") {
      switch (index) {
        case "1":
          this.setState({ withVAT1: event.target.value }, this.updatePrices);
          break;
        case "2":
          this.setState({ withVAT2: event.target.value }, this.updatePrices);
          break;
        case "3":
          this.setState({ withVAT3: event.target.value }, this.updatePrices);
          break;
        default:
      }
    } else if (what == "withoutVAT") {
      switch (index) {
        case "1":
          this.setState({ withoutVAT1: event.target.value }, this.updatePrices);
          break;
        case "2":
          this.setState({ withoutVAT2: event.target.value }, this.updatePrices);
          break;
        case "3":
          this.setState({ withoutVAT3: event.target.value }, this.updatePrices);
          break;
        default:
      }
    }
  }

  updatePrices() {
    let prices = [];
    if(this.props.prices[0].id){
      prices[0] = {
        currency: this.props.prices[0].currency,
        id: this.props.prices[0].id,
        licenceTypeId: this.props.prices[0].licenceTypeId,
        priceWithVAT: this.state.withVAT1,
        priceWithoutVAT: this.state.withoutVAT1
      };
    }else{
      prices[0] = {
        currency: this.props.prices[0].currency,
        licenceTypeId: this.props.prices[0].licenceTypeId,
        priceWithVAT: this.state.withVAT1,
        priceWithoutVAT: this.state.withoutVAT1
      };
      }

    if(this.props.prices[1].id){
      prices[1] = {
        currency: this.props.prices[1].currency,
        id: this.props.prices[1].id,
        licenceTypeId: this.props.prices[1].licenceTypeId,
        priceWithVAT: this.state.withVAT2,
        priceWithoutVAT: this.state.withoutVAT2
      };
    }else{
      prices[1] = {
        currency: this.props.prices[1].currency,
        licenceTypeId: this.props.prices[1].licenceTypeId,
        priceWithVAT: this.state.withVAT2,
        priceWithoutVAT: this.state.withoutVAT2
      };
      }

    if(this.props.prices[2].id){
      prices[2] = {
        currency: this.props.prices[2].currency,
        id: this.props.prices[2].id,
        licenceTypeId: this.props.prices[2].licenceTypeId,
        priceWithVAT: this.state.withVAT3,
        priceWithoutVAT: this.state.withoutVAT3
      };
    }else{
      prices[2] = {
        currency: this.props.prices[2].currency,
        licenceTypeId: this.props.prices[2].licenceTypeId,
        priceWithVAT: this.state.withVAT3,
        priceWithoutVAT: this.state.withoutVAT3
      };
    }

    this.props.onPriceChange(prices);
  }

  toggle(tab: any) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    const { t } = this.props;

    return (
      <div>
        <Nav tabs style={{ border: "none" }}>
          <NavItem>
            <NavLink
              className={this.state.activeTab == "1" ? "active" : ""}
              onClick={() => {
                this.toggle("1");
              }}
            >
              {this.props.prices[0].currency}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={this.state.activeTab == "2" ? "active" : ""}
              onClick={() => {
                this.toggle("2");
              }}
            >
              {this.props.prices[1].currency}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={this.state.activeTab == "3" ? "active" : ""}
              onClick={() => {
                this.toggle("3");
              }}
            >
              {this.props.prices[2].currency}
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId={"1"}>
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <AvForm className="sypal-form">
                      <AvField
                        onChange={() => this.onChange(event, "withoutVAT", "1")}
                        name="prices.priceWithoutVAT"
                        label={t('prices.withoutVAT')}
                        value={this.props.prices[0].priceWithoutVAT}
                      />
                      <AvField
                        onChange={() => this.onChange(event, "withVAT", "1")}
                        name="prices.priceWithVAT"
                        label={t('prices.withVAT')}
                        value={this.props.prices[0].priceWithVAT}
                      />
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={"2"}>
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <AvForm className="sypal-form">
                      <AvField
                        onChange={() => this.onChange(event, "withoutVAT", "2")}
                        name="prices.priceWithoutVAT"
                        label={t('prices.withoutVAT')}
                        value={this.props.prices[1].priceWithoutVAT}
                      />
                      <AvField
                        onChange={() => this.onChange(event, "withVAT", "2")}
                        name="prices.priceWithVAT"
                        label={t('prices.withVAT')}
                        value={this.props.prices[1].priceWithVAT}
                      />
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={"3"}>
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <AvForm className="sypal-form">
                      <AvField
                        onChange={() => this.onChange(event, "withoutVAT", "3")}
                        name="prices.priceWithoutVAT"
                        label={t('prices.withoutVAT')}
                        value={this.props.prices[2].priceWithoutVAT}
                      />
                      <AvField
                        onChange={() => this.onChange(event, "withVAT", "3")}
                        name="prices.priceWithVAT"
                        label={t('prices.withVAT')}
                        value={this.props.prices[2].priceWithVAT}
                      />
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

const TranslatedPricesComponent = withTranslation('licences')(LicencePrices);

export { TranslatedPricesComponent as LicencePrices };